import type { FC } from 'react';

import { getCombinedLinkFieldValueHref } from '@eneco/common/link';
import { useLinkComponent } from '@eneco/link';
import { EnecoLogo, VisuallyHidden } from '@eneco/sparky';
import { ImageLinkRendering as Props } from '@sitecore/types/manual/NavigationBar';

const ImageLink: FC<Props> = function ({ fields }) {
  const Link = useLinkComponent();
  return (
    <Link linkType={fields.link.value.linktype} linkValue={fields.link.value}>
      <a href={getCombinedLinkFieldValueHref(fields.link.value)}>
        <VisuallyHidden>{fields.link.value.text}</VisuallyHidden>
        <EnecoLogo />
      </a>
    </Link>
  );
};

export { ImageLink };
export default ImageLink;
